import { axios } from "src/common/utils";
import authHeader from "src/common/auth/authHeader";

const RequestVendorService = {};

RequestVendorService.ddlNameTitle = (data) => {
  return new Promise((resolve, reject) => {
    axios({
      headers: authHeader(),
      method: "post",
      url: `${process.env.REACT_APP_ESG_SERVICE}/api/RequestVendor/DdlNameTitle`,
      data: {
        type: data
      },
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

RequestVendorService.ddlTypeRegister = (data) => {
  return new Promise((resolve, reject) => {
    axios({
      headers: authHeader(),
      method: "post",
      url: `${process.env.REACT_APP_ESG_SERVICE}/api/RequestVendor/GetTypeRegister`,
      data: {
        type: data
      },
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

RequestVendorService.ddlSuffix = (data) => {
  return new Promise((resolve, reject) => {
    axios({
      headers: authHeader(),
      method: "post",
      url: `${process.env.REACT_APP_ESG_SERVICE}/api/RequestVendor/GetSuffix`,
      data: {
        type: data
      },
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

RequestVendorService.ddlCountry = () => {
  return new Promise((resolve, reject) => {
    axios({
      headers: authHeader(),
      method: "post",
      url: `${process.env.REACT_APP_ESG_SERVICE}/api/RequestVendor/DdlCountry`,
      data: {
        // type: data
      },
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

RequestVendorService.ddlProvinces = (data) => {
  return new Promise((resolve, reject) => {
    axios({
      headers: authHeader(),
      method: "post",
      url: `${process.env.REACT_APP_ESG_SERVICE}/api/RequestVendor/DdlProvinces`,
      data: {
        countryKey: data
      },
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

RequestVendorService.ddlDistrict = (data) => {
  return new Promise((resolve, reject) => {
    axios({
      headers: authHeader(),
      method: "post",
      url: `${process.env.REACT_APP_ESG_SERVICE}/api/RequestVendor/DdlDistrict`,
      data: {
        provinceCode: data
      },
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

RequestVendorService.ddlSubDistrict = (data) => {
  return new Promise((resolve, reject) => {
    axios({
      headers: authHeader(),
      method: "post",
      url: `${process.env.REACT_APP_ESG_SERVICE}/api/RequestVendor/DdlSubDistrict`,
      data: {
        districtCode: data
      },
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

RequestVendorService.ddlZip = (data) => {
  return new Promise((resolve, reject) => {
    axios({
      headers: authHeader(),
      method: "post",
      url: `${process.env.REACT_APP_ESG_SERVICE}/api/RequestVendor/DdlZip`,
      data: {
        subDistrictCode: data
      },
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

RequestVendorService.SearchVendor = (data) => {
  return new Promise((resolve, reject) => {
    axios({
      headers: authHeader(),
      method: "post",
      url: `${process.env.REACT_APP_ESG_SERVICE}/api/RequestVendor/SearchVendor`,
      data: {
        VendorCode: data.VendorCode,
        VendorName: data.VendorName,
        VatRegistrationNo: data.VatRegistrationNo,
        lang: data.lang,
      },
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

RequestVendorService.SaveReqData = (data) => {
  return new Promise((resolve, reject) => {
    axios({
      headers: authHeader(),
      method: "post",
      url: `${process.env.REACT_APP_ESG_SERVICE}/api/RequestVendor/SaveReqData`,
      data: {
        rdoType: data.rdoType,
        ddlTypeVendor: data.ddlTypeVendor,
        txtcitizenId: data.txtcitizenId,
        ddlPrefixName: data.ddlPrefixName,
        txtVendorNameTH: data.txtVendorNameTH,
        txtVendorNameEN: data.txtVendorNameEN,
        txtEmail: data.txtEmail,
        txtTel: data.txtTel,
        txtTel2: data.txtTel2,
        txtMobile: data.txtMobile,
        txtFax: data.txtFax,
        txtFax2: data.txtFax2,
        txtAddress: data.txtAddress,
        txtRoad: data.txtRoad,
        ddlCountry: data.ddlCountry,
        ddlProvince: data.ddlProvince,
        ddlDistrict: data.ddlDistrict,
        ddlSubDistrict: data.ddlSubDistrict,
        ddlZip: data.ddlZip,
        userAction: data.userAction,
        ddlSuffix: data.ddlSuffix
      },
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

RequestVendorService.CheckVatRegistrationNoExist = (data) => {
  return new Promise((resolve, reject) => {
    axios({
      headers: authHeader(),
      method: "post",
      url: `${process.env.REACT_APP_ESG_SERVICE}/api/RequestVendor/CheckVatRegistrationNoExist`,
      data: {
        VatRegistrationNo: data
      },
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};
export default RequestVendorService;